import {
  Alert,
  Autocomplete,
  CircularProgress,
  LinearProgress,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { GlobalContainer } from "../../common/components/Container";
import { addDentistToCase, getCase, terminateCase } from "../../api/caseApi";
import UploadedFilesContainer from "./components/UploadedFilesContainer";
import CaseDetailsDashboard from "./components/CaseDetailsDashboard";
import { Box, Stack } from "@mui/system";
import { StyledH2, StyledH3 } from "../../common/components/Title/styles";
import { useSelector } from "react-redux";
import { getDentists } from "../../api/dentistApi";
import { Controller, useForm } from "react-hook-form";
import { StyledButton } from "../../common/components/Button";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { getCaseProgress } from "../../api/caseApi";
import CaseStatusGrid from "./components/CaseStatusGrid";
import SetsProgressTable from "./components/SetsProgressTable";
import PaymentProgressTable from "./components/PaymentProgressTable";
import PaymentSummary from "../payment-summary";
import UpdateNoOfSetsDialog from "./components/UpdateNoOfSetsDialog";
import { getSets } from "../../api/caseApi";
import { getPaymentTransactionsByCaseId } from "../../api/caseApi";
import PaymentTermsSection from "./components/PaymentTermsSection";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { Snackbar } from "@mui/material";
import { StyledTabs } from "../../common/components/TabPanel/styles";
import { Tab } from "@mui/material";
import { TabPanel } from "../../common/components/TabPanel";
import { TerminationConfirmationDialog } from "../../common/components/Dialog";
import CommentSectionDialog from "./components/CommentSectionDialog";
const CaseDetails = () => {
  const [caseDetails, setCase] = useState();
  const [loading, setLoading] = useState(true);
  const [dentists, setDentists] = useState();
  const [isSubmittingDentist, setIsSubmittingDentist] = useState();
  const [currentSet, setCurrentSet] = useState(null);
  const [nextSet, setNextSet] = useState(null);
  const [setRows, setSetRows] = useState([]);
  const [paymentTransactionRows, setPaymentTransactionRows] = useState([]);
  const [openUpdateNoOfSets, setOpenUpdateNoOfSets] = useState(false);
  const [openCommentSection, setOpenCommentSection] = useState(false);

  const [leadProgressInfo, setLeadProgressInfo] = useState(null);
  const [onlineConsultationInfo, setOnlineConsultationInfo] = useState(null);
  const [f2fConsultationInfo, setF2FConsultationInfo] = useState(null);
  const [scanningInfo, setScanningInfo] = useState(null);
  const [designInfo, setDesignInfo] = useState(null);
  const [reviewDesignInfo, setReviewDesignInfo] = useState(null);
  const [openAlertSnackBar, setOpenAlertSnackBar] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [tabValue, setTabValue] = useState(0);
  const { state } = useLocation();
  const { caseId } = useParams();
  const navigate = useNavigate();
  const [alertSeverity, setAlertSeverity] = useState("");
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [currentCaseProgress, setCurrentCaseProgress] = useState(null);
  const [firstDesignCaseProgress, setFirstDesignCaseProgress] = useState(null);
  const [firstReviewCaseProgress, setFirstReviewCaseProgress] = useState(null);

  const user = useSelector((state) => state.user);
  const {
    control,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm({
    resolver: yupResolver(
      yup.object().shape({
        dentistId: yup.string("Invalid").required("Dentist is required"),
      })
    ),
  });

  useEffect(() => {
    if (user.roles.includes("Operations")) {
      const fetchDoctors = async () => {
        const response = await getDentists();
        setDentists(response.data);
      };
      fetchDoctors();
    }
  }, [user.roles]);

  const handleTerminateCase = async (values) => {
    values.caseId = caseId;
    await terminateCase(values);
    navigate("/cases");
  };

  const handleSetCurrentCaseProgress = (caseProgress) => {
    setCurrentCaseProgress(caseProgress);
  };

  const handleOpenCommentSection = async () => {
    setOpenCommentSection(true);
  };

  const handleCloseCommentSection = async () => {
    setOpenCommentSection(false);
  };

  const handleCloseUpdateNoOfSets = () => {
    setOpenUpdateNoOfSets(false);
  };
  const handleTabChange = (e, newValue) => {
    setTabValue(newValue);
  };
  const handleOpenUpdateNoOfSets = () => {
    if (
      caseDetails.alignerMaterialId === null &&
      caseDetails.termsOfPayment2 === null
    ) {
      handleOpenAlert(true);
      handleSetAlertMessage(
        "Select your aligner material and terms of payment after design first in the Payment Information section"
      );
    } else if (
      caseDetails.alignerMaterialId !== null &&
      caseDetails.termsOfPayment2 === null
    ) {
      handleOpenAlert(true);
      handleSetAlertMessage(
        "Select your terms of payment after design first in the Payment Information section"
      );
    } else if (
      caseDetails.alignerMaterialId === null &&
      caseDetails.termsOfPayment2 !== null
    ) {
      handleOpenAlert(true);
      handleSetAlertMessage(
        "Select your aligner material first in the Payment Information section"
      );
    } else {
      setOpenUpdateNoOfSets(true);
    }
  };

  const handleOpenAlert = () => {
    setOpenAlertSnackBar(true);
  };

  const handleCloseAlert = () => {
    setOpenAlertSnackBar(false);
  };

  const handleSetAlertMessage = (message, isSuccess) => {
    setAlertMessage(message);
    if (isSuccess) {
      setAlertSeverity("success");
    } else {
      setAlertSeverity("error");
    }
  };

  const getPaymentTransactions = async () => {
    const transactionsResponse = await getPaymentTransactionsByCaseId(
      caseDetails.id
    );
    console.log(caseDetails.id);
    console.log(transactionsResponse);
    setPaymentTransactionRows(transactionsResponse);
  };

  const getSetsInfo = async () => {
    const sets = await getSets(caseDetails.id);
    await fetchCase();
    sets.forEach((set, index) => {
      if (set.isDone === false) {
        setCurrentSet(set.setName);
        setNextSet(sets[index + 1]?.setName);
      }
    });
    setSetRows(sets);
  };
  const getCaseData = async () => {
    await fetchCase();
    let firstDesignCP = false;
    let firstReviewCP = false;

    const response = await getCaseProgress(caseId);
    // console.log(response);
    response.forEach((res) => {
      if (res.type === "Lead") {
        setLeadProgressInfo(res);
      } else if (res.type === "Online Consultation") {
        setOnlineConsultationInfo(res);
      } else if (res.type === "F2F Consultation") {
        setF2FConsultationInfo(res);
      } else if (res.type === "Scanning") {
        setScanningInfo(res);
      } else if (res.type === "Design") {
        if (!firstDesignCP) {
          setFirstDesignCaseProgress(res);
          firstDesignCP = true;
        }
        setDesignInfo(res);
      } else if (res.type === "Review Design") {
        if (!firstReviewCP) {
          setFirstReviewCaseProgress(res);
          firstReviewCP = true;
        }
        setReviewDesignInfo(res);
      }
    });
  };

  const fetchCase = async () => {
    const response = await getCase(caseId);
    // console.log(response);
    const mycase = response.data.data;
    setCase({
      ...mycase,
      patientName: mycase.patient.firstName + " " + mycase.patient.lastName,
      patientDOB: mycase.patient.dateOfBirth,
      dentistName: `${
        mycase.dentist == null
          ? "No dentist"
          : mycase.dentist.user.firstName + " " + mycase.dentist.user.lastName
      }`,
      dentistDOB: `${
        mycase.dentist == null ? "null" : mycase.dentist.dateOfBirth
      }`,
      dentalClinicName: `${
        mycase.dentist == null ? "null" : mycase.dentist.dentalClinic.name
      }`,
      date: mycase.createdDate,
    });

    setLoading(false);
  };

  // console.log(caseDetails);

  useEffect(() => {
    getCaseData();
  }, []);

  const handleAddDentist = async (values) => {
    if (isSubmittingDentist) return;
    setIsSubmittingDentist(true);

    try {
      const { data } = await addDentistToCase(caseId, values.dentistId);
      if (state && state.isFromManageAlina) {
        setCase((prev) => ({
          ...prev,
          dentist: data,
        }));
      } else if (state && !state.isFromManageAlina) {
        const oldState = state;
        oldState.dentist = data;
        navigate(`/cases/${oldState.id}`, { replace: true, state: oldState });
      }
    } catch (err) {
      setError("submission", {
        type: "custom",
        message: err.response.data.message,
      });
    }
    fetchCase();
    setIsSubmittingDentist(false);
  };

  const handleUpdateCaseTermsOfPayment = (id, isBeforeDesign) => {
    getCaseData();
    if (isBeforeDesign) {
      setCase((prev) => ({
        ...prev,
        termsOfPayment1Id: id,
      }));
    } else {
      setCase((prev) => ({
        ...prev,
        termsOfPayment2Id: id,
      }));
    }
  };

  let hasDentist = loading
    ? false
    : state && !state.isFromManageAlina
    ? Boolean(state.dentist)
    : Boolean(caseDetails.dentist);

  const hasTerms1 =
    caseDetails &&
    caseDetails.termsOfPayment1Id !== "00000000-0000-0000-0000-000000000000" &&
    Boolean(caseDetails.termsOfPayment1Id) &&
    !caseDetails?.termsOfPayment1?.inActive;

  const hasTerms2 =
    caseDetails &&
    caseDetails.termsOfPayment2Id !== "00000000-0000-0000-0000-000000000000" &&
    Boolean(caseDetails.termsOfPayment2Id) &&
    !caseDetails?.termsOfPayment2?.inActive;

  return (
    <>
      <Snackbar
        open={openAlertSnackBar}
        autoHideDuration={6000}
        onClose={handleCloseAlert}
      >
        <Alert
          variant="filled"
          onClose={handleCloseAlert}
          severity={alertSeverity}
          sx={{ width: "100%" }}
        >
          {alertMessage}
        </Alert>
      </Snackbar>
      {loading && (
        <Box>
          <LinearProgress />
        </Box>
      )}
      {!loading && (
        <>
          <GlobalContainer theme="purple" animated={false} bgColor={"#F0F0F0"}>
            <CaseDetailsDashboard
              type="banner"
              caseDetails={caseDetails}
              onDentistUpdate={handleAddDentist}
              isSubmittingDentist={isSubmittingDentist}
              isFromManageAlina={state.isFromManageAlina}
              fetchCase={fetchCase}
            />

            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <StyledH2 theme="purple">Status: {caseDetails.status}</StyledH2>
              {caseDetails.status !== "Terminated" && (
                <StyledButton
                  theme="green"
                  onClick={() => setShowConfirmationDialog(true)}
                  width="150px"
                  style={{ marginTop: "20px", backgroundColor: "red" }}
                >
                  Terminate Case
                </StyledButton>
              )}
            </div>
            {caseDetails.status === "Terminated" && (
              <Box>
                <Box
                  sx={{
                    padding: 4,
                    borderRadius: "10px",
                    marginBottom: "20px",
                    backgroundColor: "white",
                  }}
                >
                  <StyledH3
                    theme="green"
                    style={{ marginTop: 0, marginBotton: "10px" }}
                  >
                    Reason for Termination
                  </StyledH3>
                  {caseDetails.reasonForTermination}
                </Box>
              </Box>
            )}
            <div>
              <StyledTabs
                value={tabValue}
                onChange={handleTabChange}
                variant="scrollable"
                TabIndicatorProps={{
                  style: { display: "none" },
                }}
              >
                <Tab label="Preliminary Steps" />
                <Tab label="Uploaded Files" />
                <Tab label="Fabrication and Shipment" />
                <Tab label="Payment Information" />
              </StyledTabs>
            </div>
            <TabPanel value={tabValue} index={0} sx={{ padding: 0 }}>
              <div
                style={{
                  marginBottom: "20px",
                  padding: "20px",
                  backgroundColor: "white",
                  borderRadius: "10px",
                  borderTopLeftRadius: "0px",
                  borderTopRightRadius: "0px",
                }}
              >
                {!hasTerms1 &&
                  caseDetails.status !== "Terminated" &&
                  caseDetails.status !== "Lead" && (
                    <PaymentTermsSection
                      caseId={caseDetails.id}
                      onUpdate={handleUpdateCaseTermsOfPayment}
                      getCaseData={getCaseData}
                      isBeforeDesign={true}
                    />
                  )}

                {!hasDentist &&
                !user.roles.includes("Dentist") &&
                caseDetails.status !== "Terminated" &&
                caseDetails.status !== "Lead" ? (
                  <Box>
                    <Box
                      sx={{
                        padding: 4,
                        borderRadius: "10px",
                        border: "1px solid #d6d6d6",
                        marginBottom: "10px",
                      }}
                    >
                      {errors.submission && (
                        <Alert severity="error" sx={{ marginBottom: 1 }}>
                          {errors.submission.message}
                        </Alert>
                      )}
                      <form onSubmit={handleSubmit(handleAddDentist)}>
                        <Stack
                          alignItems="center"
                          direction="row"
                          spacing={1}
                          sx={{
                            marginBottom: "1rem",
                          }}
                        >
                          <FontAwesomeIcon
                            fontSize="22px"
                            icon={faExclamationTriangle}
                            color="#ff9800"
                          />
                          <StyledH3
                            theme="green"
                            style={{
                              marginY: 0,
                              paddingTop: 0,
                            }}
                          >
                            Select Dentist
                          </StyledH3>
                        </Stack>
                        <Stack direction="row" alignItems="center" spacing={2}>
                          <Controller
                            control={control}
                            name="dentistId"
                            render={({
                              field: { onChange },
                              fieldState: { error },
                            }) => (
                              <Autocomplete
                                autoHighlight
                                disablePortal
                                options={dentists}
                                onChange={(_, val) => {
                                  onChange(val?.id || "");
                                }}
                                getOptionLabel={(option) =>
                                  option.firstName + " " + option.lastName ||
                                  option
                                }
                                disabled={isSubmittingDentist}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    error={Boolean(error)}
                                    FormHelperTextProps={{
                                      variant: "standard",
                                    }}
                                    helperText={error && error.message}
                                  />
                                )}
                                renderOption={(props, option) => {
                                  return (
                                    <li {...props} key={option.id}>
                                      {option.firstName + " " + option.lastName}
                                    </li>
                                  );
                                }}
                                sx={{ width: "100%", maxWidth: "sm" }}
                              />
                            )}
                          />
                          <StyledButton
                            theme="green"
                            type="submit"
                            sx={{ width: "100%", maxWidth: "132px" }}
                          >
                            Select Dentist
                          </StyledButton>
                          {isSubmittingDentist && <CircularProgress />}
                        </Stack>
                      </form>
                    </Box>
                  </Box>
                ) : (
                  ""
                )}
                <div
                  style={{
                    padding: "20px",
                    border: "1px solid #d6d6d6",
                    borderRadius: "10px",
                  }}
                >
                  <CaseStatusGrid
                    caseDetails={caseDetails}
                    fetchCase={fetchCase}
                    getCaseStatusData={getCaseData}
                    handleOpenUpdateNoOfSets={handleOpenUpdateNoOfSets}
                    getPaymentTransactions={getPaymentTransactions}
                    leadProgressInfo={leadProgressInfo}
                    onlineConsultationInfo={onlineConsultationInfo}
                    f2fConsultationInfo={f2fConsultationInfo}
                    scanningInfo={scanningInfo}
                    designInfo={designInfo}
                    reviewDesignInfo={reviewDesignInfo}
                    handleOpenAlert={handleOpenAlert}
                    handleSetAlertMessage={handleSetAlertMessage}
                    handleOpenCommentSection={handleOpenCommentSection}
                    currentCaseProgress={currentCaseProgress}
                    handleSetCurrentCaseProgress={handleSetCurrentCaseProgress}
                    firstDesignCaseProgress={firstDesignCaseProgress}
                    firstReviewCaseProgress={firstReviewCaseProgress}
                  />
                </div>
              </div>
            </TabPanel>
            <TabPanel value={tabValue} index={1}>
              <div
                style={{
                  marginBottom: "20px",
                  padding: "20px",
                  backgroundColor: "white",
                  borderRadius: "10px",
                  borderTopLeftRadius: "0px",
                  borderTopRightRadius: "0px",
                }}
              >
                <div
                  style={{
                    padding: "20px",
                    borderRadius: "10px",
                    border: "1px solid #d6d6d6",
                  }}
                >
                  <UploadedFilesContainer caseDetails={caseDetails} />
                </div>
              </div>
            </TabPanel>

            <TabPanel value={tabValue} index={2}>
              <div
                style={{
                  marginBottom: "20px",
                  padding: "20px",
                  backgroundColor: "white",
                  borderRadius: "10px",
                  borderTopLeftRadius: "0px",
                  borderTopRightRadius: "0px",
                }}
              >
                <div
                  style={{
                    padding: "20px",
                    borderRadius: "10px",
                    border: "1px solid #d6d6d6",
                  }}
                >
                  <SetsProgressTable
                    caseDetails={caseDetails}
                    getSetsInfo={getSetsInfo}
                    currentSet={currentSet}
                    nextSet={nextSet}
                    setRows={setRows}
                    onEmailSent={() => {
                      handleSetAlertMessage("Email sent", true);
                      handleOpenAlert();
                    }}
                    onEmailError={() => {
                      handleSetAlertMessage(
                        "Email sending failed, please try again later"
                      );
                      handleOpenAlert();
                    }}
                    modeOfPayment={
                      caseDetails.termsOfPayment2?.modeOfPayment?.name
                    }
                    isSubscription={
                      caseDetails.termsOfPayment2?.paymentSchedules[0]
                        .paymentType === 0
                        ? true
                        : false
                    }
                    handleOpenUpdateNoOfSets={handleOpenUpdateNoOfSets}
                    getPaymentTransactions={getPaymentTransactions}
                    currentCaseProgress={currentCaseProgress}
                    handleSetCurrentCaseProgress={handleSetCurrentCaseProgress}
                    handleOpenCommentSection={handleOpenCommentSection}
                  />
                </div>
              </div>
            </TabPanel>

            <TabPanel value={tabValue} index={3}>
              <Box sx={{ padding: "0px" }}>
                <div
                  style={{
                    marginBottom: "20px",
                    padding: "20px",
                    backgroundColor: "white",
                    borderRadius: "10px",
                    borderTopLeftRadius: "0px",
                    borderTopRightRadius: "0px",
                  }}
                >
                  {!hasTerms2 &&
                    caseDetails.status !== "Terminated" &&
                    caseDetails.status !== "Lead" && (
                      <PaymentTermsSection
                        caseId={caseDetails.id}
                        onUpdate={handleUpdateCaseTermsOfPayment}
                        getCaseData={getCaseData}
                        isBeforeDesign={false}
                      />
                    )}
                  <div
                    style={{
                      padding: "20px",
                      borderRadius: "10px",
                      border: "1px solid #d6d6d6",
                    }}
                  >
                    <PaymentProgressTable
                      caseDetails={caseDetails}
                      fetchCase={fetchCase}
                      paymentTransactionRows={paymentTransactionRows}
                      getPaymentTransactions={getPaymentTransactions}
                      getCaseData={getCaseData}
                      handleOpenAlert={handleOpenAlert}
                      handleSetAlertMessage={handleSetAlertMessage}
                    />
                  </div>
                </div>
              </Box>
            </TabPanel>
          </GlobalContainer>
          <UpdateNoOfSetsDialog
            openUpdateNoOfSets={openUpdateNoOfSets}
            handleCloseUpdateNoOfSets={handleCloseUpdateNoOfSets}
            caseId={caseDetails.id}
            termsOfPayment2={caseDetails.termsOfPayment2}
            getSetsInfo={getSetsInfo}
            handleSetAlertMessage={handleSetAlertMessage}
            handleOpenAlert={handleOpenAlert}
          />
          <TerminationConfirmationDialog
            open={showConfirmationDialog}
            handleClose={() => setShowConfirmationDialog(false)}
            submit={handleTerminateCase}
            title={"Terminate Case"}
          />
          <CommentSectionDialog
            open={openCommentSection}
            onClose={handleCloseCommentSection}
            currentCaseProgress={currentCaseProgress}
          />
        </>
      )}
    </>
  );
};

export default CaseDetails;
